<script>export default {
    name: 'templatePreview',
    props: {
        type: {
            type:Number,
            default: 1
        },
        extra: {
            type: Object,
            default: () => {
                return {};
            }
        },
        services: {
            type: Array,
            default: () => {
                return [];
            }
        },
        adminInfo: {
            type: Object,
            default: () => {
                return {};
            }
        },
        showRobot: {
            type: Boolean,
            default: false
        },
        videoAccount: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    data() {
        return {
            
        }
    },
    mounted() {
        
    },
    methods: {
        
    }
}
</script>
<template>
    <div class="template-preview-box">
        <div class="template-preview" 
        :class="{'template-preview2':type == 2,'template-preview3':type == 3,'template-preview4':type == 4,
        'template-preview5':type == 5,'template-preview6':type == 6,'template-preview7':type == 7}">

            <slot></slot>

            <div class="title">{{ extra.basic_txt_1 ||'-' }}</div>
            <div class="content-box">
                <div class="content-row row">
                    <div class="line"></div>
                    <div class="label">使命</div>
                    <div class="content">{{ extra.basic_txt_2 }}</div>
                </div>
                <div class="content-line"></div>
                <div class="content-row row">
                    <div class="line"></div>
                    <div class="label">理念</div>
                    <div class="content">{{ extra.basic_txt_3 }}</div>
                </div>
                <div class="content-line"></div>
                <div class="content-row row">
                    <div class="line"></div>
                    <div class="label">愿景</div>
                    <div class="content">{{ extra.basic_txt_4 }}</div>
                </div>
            </div>
            <div class="sub-title">
                <img src="/assets/images/card-template/card-template-subtitle1.png" v-if="type == 1">
                <img src="/assets/images/card-template/card-template-subtitle1-1.png" v-else>
                <div>品牌优势</div>
            </div>
            <div class="advantage-box">
                <div class="advantage">
                    <img src="/assets/images/card-template/card-template-advantage-card.png" v-if="type == 1">
                    <img src="/assets/images/card-template/card-template-advantage-card2.png" v-else>
                    <div class="content">
                        <div>{{ extra.brand_txt_1 }}</div>
                    </div>
                </div>
                <div class="advantage">
                    <img src="/assets/images/card-template/card-template-advantage-card.png" v-if="type == 1">
                    <img src="/assets/images/card-template/card-template-advantage-card2.png" v-else>
                    <div class="content">
                        <div>{{ extra.brand_txt_2 }}</div>
                    </div>
                </div>
                <div class="advantage">
                    <img src="/assets/images/card-template/card-template-advantage-card.png" v-if="type == 1">
                    <img src="/assets/images/card-template/card-template-advantage-card2.png" v-else>
                    <div class="content">
                        <div>{{ extra.brand_txt_3 }}</div>
                    </div>
                </div>
                <div class="advantage">
                    <img src="/assets/images/card-template/card-template-advantage-card.png" v-if="type == 1">
                    <img src="/assets/images/card-template/card-template-advantage-card2.png" v-else>
                    <div class="content">
                        <div>{{ extra.brand_txt_4 }}</div>
                    </div>
                </div>
                <div class="advantage">
                    <img src="/assets/images/card-template/card-template-advantage-card.png" v-if="type == 1">
                    <img src="/assets/images/card-template/card-template-advantage-card2.png" v-else>
                    <div class="content">
                        <div>{{ extra.brand_txt_5 }}</div>
                    </div>
                </div>
                <div class="advantage">
                    <img src="/assets/images/card-template/card-template-advantage-card.png" v-if="type == 1">
                    <img src="/assets/images/card-template/card-template-advantage-card2.png" v-else>
                    <div class="content">
                        <div>{{ extra.brand_txt_6 }}</div>
                    </div>
                </div>
            </div>

            <template v-if="services.length">
                <div class="sub-title">
                    <img src="/assets/images/card-template/card-template-subtitle2.png" v-if="type == 1">
                    <img src="/assets/images/card-template/card-template-subtitle2-1.png" v-else>
                    <div>推荐专区</div>
                </div>
                <div class="service-scroll">
                    <div class="service" v-for="service in services" :key="service.summary">
                        <div class="thumb">
                            <img :src="service.thumb">
                            <div class="group">
                                <span v-if="service.group == 'serve'">服务</span>
                                <span v-if="service.group == 'courses'">课程</span>
                                <span v-if="service.group == 'activity'">活动</span>
                            </div>
                        </div>
                        <div class="name">{{ service.title }}</div>
                        <div class="summary">{{ service.summary }}</div>
                    </div>
                </div>
            </template>
            
            <div class="sub-title">
                <img src="/assets/images/card-template/card-template-subtitle3.png" v-if="type == 1">
                <img src="/assets/images/card-template/card-template-subtitle3-1.png" v-else>
                <div>关于我们</div>
            </div>
            <div class="me-box">
                <div class="avatar-box">
                    <div class="avatar">
                        <img :src="adminInfo.avatar">
                    </div>
                </div>
                <div class="name-box">
                    <div class="name">{{ adminInfo.name }}</div>
                    <img src="/assets/images/card-template/card-template-icon5-1.png" v-if="type == 1">
                    <img src="/assets/images/card-template/card-template-icon5.png" v-else>

                </div>
                <div class="video-num" v-if="videoAccount.enabled">
                    <img src="/assets/images/card-template/card-template-icon12.png">
                    <span>视频号</span>
                </div>
                <div class="summary-box">
                    <div class="label">About me</div>
                    <div class="summary">
                        {{ adminInfo.summary }}
                    </div>
                    <div class="line"></div>
                </div>
                <div class="info-row">
                    <img src="/assets/images/card-template/card-template-icon6.png">
                    <div class="info">Tel.{{ adminInfo.phone }}</div>
                </div>
                <div class="info-row">
                    <img src="/assets/images/card-template/card-template-icon7.png">
                    <div class="info">E-mail.{{ adminInfo.email }}</div>
                </div>
                <div class="info-row">
                    <img src="/assets/images/card-template/card-template-icon8.png">
                    <div class="info">Address.{{ adminInfo.address }}</div>
                </div>
                <div class="more-btn">
                    <img src="/assets/images/card-template/card-template-icon9.png" v-if="type == 1">
                    <img src="/assets/images/card-template/card-template-icon9-2.png" v-else>
                </div>
            </div>
            <div class="yc-ai">
                <img src="/assets/images/card-template/card-template-icon10.png" v-if="type == 1">
                <img src="/assets/images/card-template/card-template-icon10-1.png" v-else>
            </div>
        </div>
        
        <div v-if="showRobot" class="ai-box">
            <div class="ai-head-box">
                <img alt="" src="/assets/mp-static/images/AI-head.png">
            </div>
            <div class="eye-box">
                <img alt="" src="/assets/mp-static/images/AI-eye.png">
                <img alt="" src="/assets/mp-static/images/AI-eye.png">
            </div>
        </div>
    </div>
</template>
<style lang="less">
.row {
    display: flex;
    align-items: center;
}

@keyframes rotate {
    0% {
        transform: rotateX(0deg);
    }

    10% {
        transform: rotateX(90deg);
    }

    20% {
        transform: rotateX(180deg);
    }

    30% {
        transform: rotateX(270deg);
    }

    40% {
        transform: rotateX(360deg);
    }

    100% {
        transform: rotateX(360deg);
    }
}

.template-preview-box {
    position: absolute;
    left: 728px;
    top: 84px;
    z-index: 9;

    .ai-box {
        position: absolute;
        top: 374px;
        left: 220px;
        z-index: 99;

        .ai-head-box {
            width: 48px;
            height: 45px;

            img {
                width: 48px;
                height: 45px;
            }
        }

        .eye-box {
            width: 19px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            position: absolute;
            top: 15px;
            left: 15px;

            img {
                animation: 3s rotate infinite;
                width: 6px;
                height: 10px;
            }
        }
    }
    
    .template-preview {
        width: 375px;
        height: fit-content;
        background: url('/assets/images/card-template/card-template-bg1.png') no-repeat;
        background-size: cover;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
        transform: scale(0.747);
        transform-origin: 0 0;
        font-family: PingFang SC, PingFang SC;
        padding-top: 108px;
        position: relative;
        
        .template-select{
            position: absolute;
            left: 0;
            top: 102%;
            display: flex;
            align-items: center;
            transform: scale(1.4);
            transform-origin: 0 0;
        }
        .title {
            width: 100%;
            font-size: 32px;
            font-weight: bold;
            text-align: center;
			background: -webkit-linear-gradient(#141414, #20523B); /* 定义线性渐变 */
			-webkit-background-clip: text; /* 将背景裁剪为文本形状 */
			-webkit-text-fill-color: transparent; /* 设置文本填充颜色为透明 */
        }

        .content-box {
            width: 343px;
            background: #FFFFFF;
            box-shadow: 2px 4px 8px 0px rgba(30, 79, 57, 0.15);
            border-radius: 12px;
            margin: 24px auto 0;
            padding: 36px 46px;

            .content-row {
                .line {
                    width: 2px;
                    height: 16px;
                    margin-right: 12px;
                    background: linear-gradient( 180deg, #4F8E71 0%, #21543D 100%);
                }

                .label {
                    color: #333333;
                    font-size: 16px;
                    font-weight: bold;
                    margin-right: 24px;
                }

                .content {
                    width: 180px;
                    color: #141414;
                    font-size: 12px;
                }
            }

            .content-line {
                width: 100%;
                height: 1px;
                background: rgba(0, 0, 0, 0.1);
                margin: 24px 0;
            }
        }

        .sub-title {
            width: 159px;
            height: 33px;
            margin: 60px auto 0;
            position: relative;

            img {
                width: 159px;
                height: 33px;
            }

            div {
                width: 159px;
                height: 33px;
                line-height: 28px;
                text-align: center;
				background: -webkit-linear-gradient(#141414, #20523B); /* 定义线性渐变 */
				-webkit-background-clip: text; /* 将背景裁剪为文本形状 */
				-webkit-text-fill-color: transparent; /* 设置文本填充颜色为透明 */
                font-size: 20px;
                font-weight: bold;
                position: absolute;
                left: 0;
                top: 20px;
            }
        }

        .yc-ai {
            width: 100%;
            text-align: center;
            margin-top: 24px;

            img {
                width: 173px;
                height: 10px;
            }
        }

        .me-box {
            width: 343px;
            background: #FFFFFF;
            box-shadow: 2px 4px 8px 0px rgba(30, 79, 57, 0.15);
            border-radius: 12px;
            margin: 113px auto 0;
            padding: 0 16px 32px;
            position: relative;

            .avatar-box {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: -58px;
                left: 0;

                .avatar {
                    border: 4px solid #FFFFFF;
                    background: #FFFFFF;
                    border-radius: 32px;
                    margin: 0 auto;

                    img {
                        width: 98px;
                        height: 98px;
                        border-radius: 32px;
                        object-fit: contain;
                    }
                }
            }

            .name-box {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                padding-top: 56px;

                .name {
                    color: #141414;
                    font-size: 16px;
                    font-weight: bold;
                }

                img {
                    width: 20px;
                    height: 20px;
                    margin-left: 8px;
                }
            }

            .video-num{
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 4px;
                img{
                    width: 16px;
                    height: 16px;
                    margin-right: 4px;
                }
                span{
                    color: #FBB03B;
                    font-size: 12px;
                    font-weight: bold;
                }
            }

            .summary-box {
                width: 100%;
                margin-top: 24px;

                .label {
                    color: #141414;
                    font-size: 14px;
                    font-weight: bold;
                }

                .summary {
                    color: rgba(20, 20, 20, 0.6);
                    font-size: 12px;
                    line-height: 17px;
                    margin-top: 16px;
                    white-space: pre-wrap;
                }

                .line {
                    width: 100%;
                    height: 1px;
                    background: rgba(32, 82, 59, 0.1);
                    margin-bottom: 16px;
                }
            }

            .info-row {
                width: 100%;
                display: flex;
                align-items: center;
                margin-bottom: 8px;

                img {
                    width: 20px;
                    height: 20px;
                    margin-right: 16px;
                }

                div {
                    color: #999999;
                    font-size: 12px;
                }
            }

            .more-btn {
                width: 100%;
                text-align: center;
                position: absolute;
                bottom: 0;
                left: 0;

                img {
                    width: 85px;
                    height: 21px;
                }
            }
        }

        .service-scroll {
            width: 100%;
            height: 300px;
            margin-top: 24px;
            overflow: hidden;
            white-space: nowrap;
            padding-left: 20px;

            .service {
                display: inline-block;
                width: 306px;
                height: 258px;
                background: #FFFFFF;
                box-shadow: 2px 4px 8px 0px rgba(30, 79, 57, 0.15);
                border-radius: 12px;
                margin-right: 20px;

                .thumb {
                    width: 100%;
                    height: 180px;
                    border-radius: 12px 12px 0 0;
                    position: relative;

                    .group {
                        width: 48px;
                        height: 18px;
                        background: rgba(0,0,0,0.2);
                        border-radius: 4px;
                        border: 1px solid #FFFFFF;
                        position: absolute;
                        top: 12px;
                        right: 12px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #FFFFFF;
                        font-size: 10px;
                    }
                    img {
                        width: 100%;
                        height: 100%;
                        border-radius: 12px 12px 0 0;
                        object-fit: cover;
                    }
                }

                .name {
                    color: #141414;
                    font-size: 14px;
                    font-weight: bold;
                    line-height: 20px;
                    margin-top: 10px;
                    margin-bottom: 4px;
                    padding: 0 16px;
                }

                .summary {
                    color: #141414;
                    font-size: 12px;
                    line-height: 17px;
                    white-space: normal;
                    padding: 0 16px;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
            }
        }

        .advantage-box {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            padding: 0 20px;
            margin-top: 55px;

            .advantage {
                width: 158px;
                height: 72px;
                background: rgba(255, 255, 255, 0.6);
                box-shadow: 2px 4px 8px 0px rgba(30, 79, 57, 0.15);
                border-radius: 12px;
                margin-bottom: 16px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;

                img {
                    width: 150px;
                    height: 48px;
                }

                .content {
                    width: 100%;
                    height: 100%;
                    padding: 0 43px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: absolute;
                    top: 0;
                    left: 0;

                    div {
                        color: #141414;
                        font-size: 12px;
                        text-align: center;
                    }
                }
            }
        }
    }
    .template-preview2,.template-preview3,.template-preview4,.template-preview5,.template-preview7{
        background: url('/assets/images/card-template/card-template-bg2-1.png') no-repeat;
        background-size: cover;

		.title {
			background: -webkit-linear-gradient(#FFFFFF, #FFFFFF); /* 定义线性渐变 */
			-webkit-background-clip: text; /* 将背景裁剪为文本形状 */
			-webkit-text-fill-color: transparent; /* 设置文本填充颜色为透明 */
		}
		.sub-title{
			div{
				background: -webkit-linear-gradient(#FFFFFF, #FFFFFF); /* 定义线性渐变 */
				-webkit-background-clip: text; /* 将背景裁剪为文本形状 */
				-webkit-text-fill-color: transparent; /* 设置文本填充颜色为透明 */
			}
		}

        .content-box {
            // background: rgba(255,255,255,0.6);
            background: url('/assets/images/card-template/card-bg.png') no-repeat;
            background-size: 140% 140%;
            background-position: center center;
            backdrop-filter: blur(32px);
            .content-row{
				.line {
					width: 2px;
					height: 16px;
					margin-right: 12px;
					background: linear-gradient(180deg, #827262 0%, #000000 100%);
				}
			}
        }

        .advantage-box{
            .advantage{
                background: url('/assets/images/card-template/card-bg.png') no-repeat;
                background-size: 130% 130%;
                background-position: center center;
                backdrop-filter: blur(32px);
            }
        }
    }
    .template-preview3{
        background: url('/assets/images/card-template/card-template-bg3.png') no-repeat;
        background-size: cover;
    }
    .template-preview4{
        background: url('/assets/images/card-template/card-template-bg4.png') no-repeat;
        background-size: cover;
    }
    .template-preview5{
        background: url('/assets/images/card-template/card-template-bg5.png') no-repeat;
        background-size: cover;
    }
    .template-preview6{
        background: url('/assets/images/card-template/card-template-bg6.png') no-repeat;
        background-size: cover;
    }
    .template-preview7{
        background: url('/assets/images/card-template/card-template-bg7.png') no-repeat;
        background-size: cover;
    }
}


</style>